<template>
  <InfoTooltip :text="text" link="/attachments/short_sk/SPORT.pdf" linkText="Otvoriť podrobný popis športov"/>
</template>

<script>
import InfoTooltip from "@/components/InfoTooltip.vue";

export default {
  name: "SportInfoTooltip",
  components: {InfoTooltip},
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
